import { FETCH_TRENDING, RESET, SELECT_TAB, FETCH_NEXT, SET_FETCHING } from './BrowseActions';
import {
  filterSearchResults,
  reduceSearchResults,
  transformSearchFilters,
  reduceBrowseResults,
  getUniqueItemsById,
} from './components/FindProcessor';
import { FETCH_NEXT_SEARCH, SET_SEARCH_DATA } from './SearchActions';

const INITIAL_STATE = {
  browseFilters: [],
  browseResults: {},
  searchFilters: [],
  searchResults: {},
  error: false,
  fetching: false,
};

export default function(state = INITIAL_STATE, action) {
  const data = action?.payload?.data ?? null;
  switch (action.type) {
    case FETCH_TRENDING: {
      if (!data) return state;
      return {
        ...state,
        browseFilters: [{ headline: 'Popular', id: 'trending' }],
        browseResults: reduceBrowseResults(data?.result),
        selectedTab: 'trending',
      };
    }
    case FETCH_NEXT: {
      const browseResults = state?.browseResults ?? {};
      const selectedTab = 'trending';
      const currentFilter = browseResults?.[selectedTab] ?? [];
      const result = data?.result;
      const newItems = result?.member ?? [];
      const id = result?.view?.['@id'] ?? null;
      let newNext = result?.view?.next ?? null;
      if (newNext === id) newNext = null;
      const results = getUniqueItemsById([...(currentFilter?.items ?? []), ...newItems]);
      return {
        ...state,
        browseResults: {
          ...browseResults,
          [selectedTab]: {
            ...browseResults?.[selectedTab],
            items: results,
            next: newNext,
          },
        },
        fetching: false,
      };
    }
    case SET_SEARCH_DATA: {
      const results = filterSearchResults(action?.payload ?? []);
      const resultsObj = reduceSearchResults(results);
      const searchFilters = transformSearchFilters(results);
      return {
        ...state,
        fetching: false,
        searchFilters,
        searchResults: { ...(state?.searchResults ?? []), ...resultsObj },
        selectedTab: results[0]?.id ?? '',
      };
    }

    case FETCH_NEXT_SEARCH: {
      const { searchResults } = state;
      const selectedTab = data?.filterName ?? '';
      const currentFilter = searchResults?.[selectedTab];
      const newItems = data?.result?.member ?? [];
      const previousItems = currentFilter?.items ?? [];
      const results = getUniqueItemsById([...previousItems, ...newItems]);
      const id = data?.result?.view?.['@id'] ?? null;
      let newNext = data?.result?.view?.next ?? null;
      if (newNext === id) newNext = null;

      return {
        ...state,
        fetching: false,
        searchResults: {
          ...searchResults,
          [selectedTab]: {
            ...searchResults?.[selectedTab],
            items: results,
            next: newNext,
          },
        },
      };
    }

    case SET_FETCHING: {
      const value = action?.payload;
      return {
        ...state,
        fetching: value,
      };
    }
    case RESET: {
      return INITIAL_STATE;
    }
    case SELECT_TAB: {
      return {
        ...state,
        selectedTab: action?.payload,
      };
    }

    default: {
      return state;
    }
  }
}
